
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "UserPersonalData",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {    
    const request = reactive({
      apiLoadMethod: "api/Form/loadForm",
      apiSaveMethod: "",
      form: "Benutzer",
      page: "BenutzerPersonendaten",
      remoteId: "",
      waitForResponse: true
      
    });

    return {
      request
    };
  }
};
